// src/components/ItemCard.jsx
import React from 'react';
import { getStatus, expiryLabel, CATS } from '../lib/utils';

const LOC = { sec:'lsec', frigo:'lfrigo', congelateur:'lconge', boissons:'lboissons', autre:'lsec' };

export default function ItemCard({ item, alertDays, onEdit, onDelete, onQty }) {
  const st = getStatus(item.expiry, alertDays);
  const el = expiryLabel(item.expiry);
  const ec = st === 'ok' ? 'eok' : st === 'soon' ? 'esoon' : 'eexp';

  return (
    <div className={`icard ${st}`}>
      <div className="iemoji">{item.emoji}</div>
      <div className="iinfo">
        <div className="iname">{item.name}</div>
        <div className="imeta">
          <span className={`mtag lbadge ${LOC[item.cat] || 'lsec'}`}>
            {CATS[item.cat]?.icon} {CATS[item.cat]?.label || item.cat}
          </span>
          {el && <span className={`mtag ${ec}`}>{el}</span>}
          {item.note && <span className="mtag">{item.note}</span>}
        </div>
      </div>
      <div className="iright">
        <div className="qrow">
          <button className="qbtn" onClick={() => onQty(item.id, -1)}>−</button>
          <span className="qval">{item.qty}</span>
          <button className="qbtn" onClick={() => onQty(item.id, +1)}>+</button>
        </div>
        <div className="actrow">
          <span style={{ fontSize:10, color:'var(--muted)' }}>{item.unit || 'unité(s)'}</span>
          <button className="dbtn" onClick={() => onEdit(item)}>✏️</button>
          <button className="dbtn" onClick={() => onDelete(item)}>🗑️</button>
        </div>
      </div>
    </div>
  );
}
